import { mutate } from 'swr'

import { putJson } from '../../../../data/fetchers'
import { EInvoiceConfig, GeneralSettings } from './model'

// General settings
export async function requestUpdateGeneralSettings(dto: GeneralSettings) {
  await putJson('/selfservices/generalsettings', dto)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith('/selfservices/generalsettings'.toLowerCase()),
  )
}

// E-Invoice
export async function requestUpdateEInvoiceConfig(dto: EInvoiceConfig) {
  await putJson('/selfservices/einvoice', dto)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith('/selfservices/einvoice'.toLowerCase()),
  )
}
